import { useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { EMAIL, NAV } from "../../data/content";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-white/10">
      <div className="flex items-center justify-between px-6 lg:px-12 h-20">
        <a href="#top" data-testid="header-wordmark" className="leading-none">
          <span className="font-mono text-base lg:text-lg tracking-[0.25em] text-white">
            A-SQUARE GROUP
          </span>
          <span className="block mt-1 font-mono text-[10px] tracking-[0.35em] text-white/50">
            GOVERNANCE · SYSTEMS · INTELLIGENCE
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-10" data-testid="header-nav">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="font-mono text-xs tracking-[0.25em] text-white/70 hover:text-white transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href={`mailto:${EMAIL}`}
            data-testid="header-engage-btn"
            className="hidden sm:inline-flex items-center gap-2 border border-white/30 px-6 py-3 font-mono text-xs tracking-[0.25em] text-white hover:bg-white hover:text-black transition-colors duration-300"
          >
            ENGAGE <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-[#0A0A0A] px-6 py-6 flex flex-col gap-5" data-testid="mobile-nav">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              className="font-mono text-sm tracking-[0.25em] text-white/80"
            >
              {item.label}
            </a>
          ))}
          <a
            href={`mailto:${EMAIL}`}
            data-testid="mobile-engage-btn"
            className="inline-flex items-center gap-2 border border-white/30 px-6 py-3 font-mono text-xs tracking-[0.25em] text-white w-fit"
          >
            ENGAGE <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </nav>
      )}
    </header>
  );
};
